var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sliderScoreDownload
    ? _c("div", [_c("div", { ref: "chart", staticStyle: { height: "234px" } })])
    : _c("div", { staticClass: "yxtbiz-as-report__bar flex" }, [
        _c(
          "div",
          {
            staticClass:
              "yxtbiz-as-report__bar--yaxis color-gray-6 flex flex-vertical flex-between",
          },
          [
            _vm._l(_vm.getValueLabelData().reverse(), function (item) {
              return [
                _c(
                  "yxt-tooltip",
                  {
                    key: item,
                    attrs: {
                      effect: "light",
                      content: item,
                      "open-filter": "",
                      placement: "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "ellipsis" }, [
                      _vm._v(_vm._s(item)),
                    ]),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
        _c(
          "div",
          {
            ref: "chartWrap",
            staticClass: "yxtbiz-as-report__bar--wrap flex-1 w0",
          },
          [
            _c("yxt-scrollbar", { attrs: { "fit-height": true } }, [
              _c("div", { ref: "chart" }),
              _c(
                "div",
                {
                  ref: "chartX",
                  staticClass: "flex standard-size-12 color-gray-7",
                },
                [
                  _vm._l(_vm.getCategoryLabelData(), function (item) {
                    return [
                      _c(
                        "yxt-tooltip",
                        {
                          key: item,
                          attrs: {
                            effect: "light",
                            content: item,
                            "open-filter": "",
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex-1 text-center ellipsis-2 ph4",
                            },
                            [_vm._v(_vm._s(item))]
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }